import React, { Component } from 'react';
import { connect } from 'react-redux';
import { login, loginFacebook, createUser } from '../../../redux/modules/user';
import { saveSourceMedium } from '../../../redux/modules/checkout';
import TopHeaderPrimary from './TopHeader/TopHeaderPrimary';
import TopHeaderSecondary from './TopHeader/TopHeaderSecondary';
import HeaderMenu from './HeaderMenu/HeaderMenu';
import CheckoutHeader from './CheckoutHeader/CheckoutHeader';
import AddedToCart from './AddedToCart/AddedToCart';
import { primary_s26_l96 } from '../../shared/lib/colors';
import IubendaCookieSolution from '../../../utils/iubenda';
import { optimonkSetCart, setAttribute } from '../lib/optimonk';

import './Header.scss';
import { isArrayEqual } from '../../../utils/array';

const round2Decimals = num => Math.round((num + Number.EPSILON) * 100) / 100;

class Header extends Component {
  componentDidMount() {
    // get visit data
    this._getMediumSource();

    if (this.props.hasCriteo) {
      // <!-- Criteo Loader File -->
      const criteo = document.createElement('script');
      criteo.type = 'text/javascript';
      criteo.src = `//dynamic.criteo.com/js/ld/ld.js?a=${this.props.criteoAccountId}`;
      criteo.async = true;

      const iubenda = new IubendaCookieSolution(
        this.props.hasIubendaCookieSolution
      );
      iubenda.proceedIfHasConsent(() => document.body.appendChild(criteo));
      // <!-- END Criteo Loader File -->
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (!isArrayEqual(prevProps.cart, this.props.cart) &&
        !!prevProps.cart.length &&
        !!this.props.cart.length) ||
      prevProps.cart.length !== this.props.cart.length
    ) {
      setAttribute(
        'cart',
        round2Decimals(
          this.props.cart.reduce(
            (acc, item) => acc + item.price * item.quantity,
            0
          )
        )
      );
      optimonkSetCart(this.props.cart);
    }
    if (prevProps.user.id !== this.props.user.id) {
      if (!!this.props.user.id) {
        setAttribute('guest', false);
      } else {
        setAttribute('guest', true);
      }
    }
  }

  _getMediumSource = () => {
    let medium = sessionStorage.getItem('medium');
    let source = sessionStorage.getItem('source');
    if ((!medium || !source) && !!window.visitData) {
      const visitData = window.visitData.get();
      medium = visitData.medium;
      source = visitData.source;
      if (!!medium && !!source) {
        sessionStorage.setItem('medium', medium);
        sessionStorage.setItem('source', source);
      }
    }
    this.props.saveSourceMedium({ medium, source });
  };

  renderBackgroundVersion = uiVariantBackground => {
    switch (uiVariantBackground) {
      case '1':
        return primary_s26_l96(this.props.primaryColor);
      case '2':
        return '#f6f6f6';
      case '3':
        return '#fff';
      default:
        return uiVariantBackground;
    }
  };

  render() {
    const {
      isCheckout,
      login,
      user,
      isAuthenticated,
      phone,
      phone2,
      shippingDescription,
      primaryColor,
      secondaryColor,
      headerMenuOpen,
      loginFacebook,
      createUser,
      freeShippingThreshold,
      headerDescription,
      headerAppLink,
      companyName,
      datiFarmacia,
      categoryTags,
      headerAppLinkAndroid,
      headerAppLinkIos,
    } = this.props;

    const getHeader = module => {
      return (
        <header
          id="farmakom-header"
          className={`${
            isCheckout ? 'header-checkout' : 'header-not-checkout'
          } ${headerMenuOpen ? 'menu-open' : 'menu-closed'}`}
          style={{
            backgroundColor: isCheckout ? '' : primaryColor,
            overflow: 'visible',
            maxWidth: '100vw',
          }}
        >
          {module.moduleVersion !== 1 && (
            <TopHeaderSecondary
              topHeaderSecondaryVersion={module.moduleVersion}
              phone={phone}
              phone2={phone2}
              primaryColor={primaryColor}
              secondaryColor={secondaryColor}
              shippingDescription={shippingDescription}
              freeShippingThreshold={freeShippingThreshold}
              headerDescription={headerDescription}
              datiFarmacia={datiFarmacia}
            />
          )}

          <TopHeaderPrimary
            isCheckout={isCheckout}
            user={user}
            isAuthenticated={isAuthenticated}
            onLogin={login}
            onLoginFacebook={loginFacebook}
            createUser={createUser}
            phone={phone}
            phone2={phone2}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            shippingDescription={shippingDescription}
            freeShippingThreshold={freeShippingThreshold}
            headerDescription={headerDescription}
            headerAppLink={headerAppLink}
            headerAppLinkAndroid={headerAppLinkAndroid}
            headerAppLinkIos={headerAppLinkIos}
            topHeaderVersion={module.moduleVersion}
          />

          {isCheckout ? (
            <CheckoutHeader />
          ) : (
            <HeaderMenu
              user={user}
              isAuthenticated={isAuthenticated}
              onLogin={login}
              phone={phone}
              primaryColor={primaryColor}
              secondaryColor={secondaryColor}
              onLoginFacebook={loginFacebook}
              createUser={createUser}
              companyName={companyName}
              categoryTags={categoryTags}
              headerMenuVersion={module.moduleVersion}
            />
          )}

          <AddedToCart />
        </header>
      );
    };

    return (
      <>
        {this.props.homePageConfiguration.map(module => {
          if (module.moduleType === 'Header') {
            return getHeader(module);
          }
        })}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.data,
  cart: state.cart,
  isAuthenticated: state.user.authenticated,
  phone: state.store.data.datiFarmacia.phone,
  phone2: state.store.data.datiFarmacia.phone2,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  secondaryColor: state.store.data.loghiTemplate.secondaryColor,
  headerMenuOpen: state.showHeaderMenu.headerMenuOpen,
  uiVariantBackground: state.store.data.uiVariants.background,
  hasCriteo: state.store.data.features.hasCriteo,
  criteoAccountId: state.store.data.integrazioni.criteo.accountId,
  hasIubendaCookieSolution: state.store.data.features.hasIubendaCookieSolution,
  shippingDescription: state.store.data.home.shippingDescription,
  headerDescription: state.store.data.home.headerDescription,
  headerAppLink: state.store.data.home.headerAppLink,
  headerAppLinkAndroid: state.store.data.home.headerAppLinkAndroid,
  headerAppLinkIos: state.store.data.home.headerAppLinkIos,
  freeShippingThreshold: state.store.data.costiSpedizione.freeShippingThreshold,
  homePageConfiguration: state.store.data.home.homePageConfiguration,
  companyName: state.store.data.datiFarmacia.companyName,
  datiFarmacia: state.store.data.datiFarmacia,
  categoryTags: state.categories.data.tags,
});

export default connect(mapStateToProps, {
  login,
  loginFacebook,
  createUser,
  saveSourceMedium,
})(Header);
